import { StriimModal, StriimTheme, StriimTypography } from "@striim/striim-ui";
import { Grid, CircularProgress } from "@mui/material";

interface LoadingModalProps {
    isModalVisible: boolean;
    content: string;
}

const styles = {
    circularProgressBase: {
        position: "absolute",
        width: 100
    },
    outerCircularProgress: {
        color: ({ palette }) => palette.greyscale[300]
    },
    gridContainer: {
        justifyContent: "center"
    }
};

const LoadingModal = ({ isModalVisible, content }: LoadingModalProps) => {
    const customCircularProgress = (
        <div>
            <CircularProgress
                variant="determinate"
                size={20}
                thickness={8}
                value={100}
                sx={{ ...styles.circularProgressBase, ...styles.outerCircularProgress }}
            />
            <CircularProgress disableShrink color="secondary" size={20} thickness={8} />
        </div>
    );
    return (
        <StriimTheme>
            <StriimModal
                autoHeight
                isVisible={isModalVisible}
                titleContent={<></>}
                footerContent={<></>}
                cancelContent={null}
                confirmContent={null}
            >
                <Grid container gap={1} sx={styles.gridContainer}>
                    <Grid item>{customCircularProgress}</Grid>
                    <Grid item>
                        <StriimTypography variant="body4" color="greyscale.800">
                            {content}
                        </StriimTypography>
                    </Grid>
                </Grid>
            </StriimModal>
        </StriimTheme>
    );
};

export default LoadingModal;
